import "../style.css";
import React from "react";
import { useTranslation } from "react-i18next";
import { sortByMyPageBookings } from "../../../../../../utils/dataLists";
import { SearchIcon, DownloadNarrowIcon } from "../../../../../../components/icons";

const BookingListFilter = ({
    changeFilter,
    selectedCards,
    filterGetBookings
}) => {
    const { t, i18n } = useTranslation();
    const currentLanguage = i18n.language;

    return (
        <>
            <div className="tw:hidden tw:md:block">
                <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:justify-between">
                    {/* <div className="tw:px-[calc(var(--gx)/2)] tw:w-1/2 tw:flex-none">
                        <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)]">
                            <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:pr-0">
                                <button
                                    type="button"
                                    name=""
                                    id=""
                                    className="tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:border-transparent tw:px-3 tw:py-[0.375rem] tw:text-base tw:rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:disabled:opacity-65 tw:disabled:pointer-events-none btn-black tw:rounded-[0.375rem] tw:px-6 tw:mx-0"
                                    disabled={selectedCards.length > 0 ? false : true}
                                >
                                    <span className="tw:text-white!">
                                        <div className="tw:block tw:min-h-[1.5rem] tw:pl-6 tw:mb-1 tw:flex tw:items-center tw:justify-center tw:gap-2 tw:m-0">
                                            <input className="tw:w-4 tw:h-4 tw:align-top tw:bg-white tw:border tw:border-[rgba(0,0,0,0.25)] tw:appearance-auto tw:accent-[#d4b055] tw:mt-0" type="checkbox" value="" id="selectBooking" />
                                            <label className=" fw-400" htmlFor="selectBooking"> {t("Select Booking(s)")} </label>
                                        </div>
                                    </span>
                                </button>
                            </div>
                            <div className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none">
                                <button
                                    type="button"
                                    name=""
                                    id=""
                                    className="tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:border-transparent tw:px-3 tw:py-[0.375rem] tw:text-base tw:rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:disabled:opacity-65 tw:disabled:pointer-events-none btn-grey tw:rounded-[0.375rem] tw:px-6 tw:mx-0 tw:py-2"
                                    disabled={selectedCards.length > 0 ? false : true}
                                >
                                    <span className="tw:flex tw:items-center tw:justify-center tw:gap-2 tw:m-0">
                                        <DownloadNarrowIcon color="#FFFFFF" />
                                        <p className="tw:text-white! tw:m-0 tw:p-0">
                                            {t("Download Receipt")}
                                        </p>
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div> */}
                    <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none">
                        <div className="tw:flex tw:w-full tw:items-center tw:justify-between tw:gap-3">
                            <div className="tw:flex tw:h-[45px] tw:w-[290px] tw:items-center tw:rounded-[5px] tw:border tw:border-[#E8E8E8] tw:bg-white tw:px-[15px] tw:py-[10px]">
                                <svg className="tw:size-[18px] tw:shrink-0 tw:text-[#7C7B7B]" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                    <path d="M3 5.5H15" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
                                    <path d="M5.5 9H12.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
                                    <path d="M8 12.5H10" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
                                </svg>
                                <div className="tw:relative tw:mx-2 tw:flex-1">
                                    <select
                                        name="sortBy"
                                        className="tw:h-full tw:w-full tw:appearance-none tw:border-0 tw:bg-transparent tw:p-0 tw:pr-6 tw:font-hanken-grotesk tw:text-[15px] tw:font-normal tw:leading-[22px] tw:text-[#282828] tw:focus:outline-none"
                                        value={filterGetBookings?.sortBy}
                                        onChange={(e) => changeFilter(e)}
                                    >
                                        {
                                            sortByMyPageBookings.map((v) => (
                                                <option key={v.value} value={v.value}>{v.label[currentLanguage]}</option>
                                            ))
                                        }
                                    </select>
                                    <svg className="tw:pointer-events-none tw:absolute tw:right-0 tw:top-1/2 tw:h-[6px] tw:w-[10px] tw:-translate-y-1/2 tw:text-[#7C7B7B]" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                        <path d="M1 1L5 5L9 1" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                            </div>
                            <div className="tw:h-[45px] tw:w-[350px] tw:rounded-[5px] tw:border tw:border-[#E8E8E8] tw:bg-white tw:px-[15px] tw:py-[10px]">
                                <div className="tw:flex input-container tw:gap-2 tw:h-full tw:items-center">
                                        <SearchIcon className="tw:mr-1 tw:size-[13px] tw:shrink-0" />
                                        <input
                                            className="input-field-search tw:w-full tw:rounded-[0.375rem] tw:border-0 tw:py-2 no-calendar tw:pr-4 tw:pl-0 tw:h-full tw:bg-transparent tw:p-0 tw:font-hanken-grotesk tw:text-[15px] tw:font-normal tw:leading-[22px] tw:text-[#282828]"
                                            type={"text"}
                                            id={"search"}
                                            name={"search"}
                                            placeholder={t('myPage.booking.bookingListFilter.search')}
                                            onChange={(e) => changeFilter(e)}
                                            value={filterGetBookings.search}
                                        />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="tw:block tw:md:hidden">
                <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)]">
                    <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:pb-2">
                        <select
                        name="sortBy"
                        onChange={(e) => changeFilter(e)}
                        className="tw:block tw:w-full tw:appearance-none tw:[font-family:var(--font-sans-primary)] tw:text-[15px] tw:text-[#4e4e4e] tw:bg-white tw:rounded-[0.3rem] tw:border tw:border-[#E8E8E8] tw:pt-2 tw:pb-[0.375rem] tw:pl-3 tw:pr-9 tw:leading-normal tw:bg-[url(data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20viewBox=%270%200%2016%2016%27%3e%3cpath%20fill=%27none%27%20stroke=%27%23343a40%27%20stroke-linecap=%27round%27%20stroke-linejoin=%27round%27%20stroke-width=%272%27%20d=%27M2%205l6%206%206-6%27/%3e%3c/svg%3e)] tw:bg-no-repeat tw:bg-[right_0.75rem_center] tw:bg-[length:16px_12px] tw:focus:border-black tw:focus:outline-none tw:h-[45px] tw:rounded-[5px] tw:font-hanken-grotesk tw:font-normal tw:leading-[22px] tw:text-[#282828]"
                        value={filterGetBookings?.sortBy}
                        >
                            {
                                sortByMyPageBookings.map((v) => (
                                    <option key={v.value} value={v.value}>{v.label[currentLanguage]}</option>
                                ))
                            }
                        </select>
                    </div>
                    <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:pb-2">
                        <div className="tw:h-[45px] tw:rounded-[5px] tw:border tw:border-[#E8E8E8] tw:bg-white tw:px-[15px] tw:py-[10px]">
                            <div className="tw:flex input-container tw:gap-2 tw:h-full tw:items-center">
                                <SearchIcon className="tw:mr-1 tw:size-[13px] tw:shrink-0" />
                                <input
                                    className="input-field-search tw:w-full tw:rounded-[0.375rem] tw:border-0 tw:py-2 no-calendar tw:pr-4 tw:pl-0 tw:h-full tw:bg-transparent tw:p-0 tw:font-hanken-grotesk tw:text-[15px] tw:font-normal tw:leading-[22px] tw:text-[#282828]"
                                    type={"text"}
                                    id={"search"}
                                    name={"search"}
                                    placeholder={t('myPage.booking.bookingListFilter.search')}
                                    onChange={(e) => changeFilter(e)}
                                    value={filterGetBookings.search}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)]">
                    {/* <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:mb-2">
                        <button
                            type="button"
                            name=""
                            id=""
                            className="tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:border-transparent tw:px-3 tw:py-[0.375rem] tw:text-base tw:rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:disabled:opacity-65 tw:disabled:pointer-events-none btn-black tw:rounded-[0.375rem] tw:w-full"
                            disabled={selectedCards.length > 0 ? false : true}
                        >
                            <span className="tw:text-white!">
                                <div className="tw:block tw:min-h-[1.5rem] tw:pl-6 tw:mb-1 tw:flex tw:items-center tw:justify-center tw:gap-2 tw:m-0">
                                    <input className="tw:w-4 tw:h-4 tw:align-top tw:bg-white tw:border tw:border-[rgba(0,0,0,0.25)] tw:appearance-auto tw:accent-[#d4b055] tw:mt-0" type="checkbox" value="" id="selectBooking" />
                                    <label className=" fw-400" htmlFor="selectBooking"> {t("Select Booking(s)")} </label>
                                </div>
                            </span>
                        </button>
                    </div> */}
                    <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:mb-2 tw:hidden">
                        <button
                            type="button"
                            name=""
                            id=""
                            className="tw:inline-block tw:font-normal tw:leading-normal tw:text-center tw:no-underline tw:align-middle tw:cursor-pointer tw:select-none tw:border tw:border-transparent tw:px-3 tw:py-[0.375rem] tw:text-base tw:rounded-[0.25rem] tw:transition-[color,background-color,border-color,box-shadow] tw:duration-150 tw:disabled:opacity-65 tw:disabled:pointer-events-none btn-grey tw:rounded-[0.375rem] tw:px-6 tw:mx-0 tw:py-2 tw:w-full"
                            disabled={selectedCards.length > 0 ? false : true}
                        >
                            <span className="tw:flex tw:items-center tw:justify-center tw:gap-2 tw:m-0">
                                <DownloadNarrowIcon color="#FFFFFF" />
                                <p className="tw:text-white! tw:m-0 tw:p-0">
                                    {t("Download Receipt")}
                                </p>
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BookingListFilter;
